import axios from 'axios';
import { API_PATHS } from 'common/utils/constants/api.constants';
import PortfolioList, { PortfolioStatus } from 'modules/sales-policies/types/sales-portfolio.interfaces';

class SalesPortfolioService {
  public static getSalesPortfolioCountByStatus(
    policyNo: string,
    pageNo: number,
    size: number
  ): Promise<PortfolioStatus> {
    return axios
      .get(`${API_PATHS.PORTFOLIO_STATUS_COUNTER}`, {
        params: {
          policyNo: policyNo,
          page: pageNo,
          size: size,
        },
      })
      .then((r) => r.data);
  }

  public static getFilteredSalesPortfolio(
    policyNo: string,
    policyStatus: string,
    pageNo: number,
    pageSize: number,
    productName?: string,
    productDescription?: string
  ): Promise<PortfolioList> {
    return axios
      .get(`${API_PATHS.PORTFOLIO_LIST}`, {
        params: {
          pageNo,
          pageSize,
          policyNo,
          policyStatus,
          productName,
          productDescription,
        },
      })
      .then((r) => r.data);
  }

  public static getAllQuoteLines(policyNo: string, categoryId: string): Promise<PortfolioList> {
    return axios
      .get(`${API_PATHS.PORTFOLIO_ALL_QUOTE_LINES}`, {
        params: {
          pageNo: 1,
          pageSize: 100,
          policyNo,
          policyStatus: 'Q',
          categoryId,
        },
      })
      .then((r) => r.data);
  }

  public static deleteQuoteLine(uuid: string[]): Promise<any> {
    return axios.delete(`${API_PATHS.PORTFOLIO_DELETE_QUOTE_LINE}`, {
      params: {
        uuid: uuid,
      },
    });
  }

  public static deleteQuote(policyNo: string): Promise<any> {
    return axios.post(`${API_PATHS.PORTFOLIO_DELETE_QUOTE}`, {
      policyNo: policyNo,
    });
  }

  public static getProductDetails(productId?: string): Promise<any> {
    return axios
      .get(`${API_PATHS.PRODUCT_DETAILS}`, {
        params: {
          productId: productId,
        },
      })
      .then((r) => r.data);
  }

  public static getRecentClaimStatus(policyNo: string, policyLineNo: string) {
    return axios
      .get(`${API_PATHS.CUSTOMER_CLAIM_STATUS}`, {
        params: {
          policyNo: policyNo,
          policyLineNo: policyLineNo,
        },
      })
      .then((res) => res.data);
  }
}
export default SalesPortfolioService;
